import axiosClient from './axiosClient'

export const fetchCommunity = async ({ page = 1, limit = 20, signal } = {}) => {
  const { data } = await axiosClient.get('/api/users/discover/community', {
    params: { page, limit },
    signal
  })
  return data
}

export const fetchNearby = async ({ page = 1, limit = 20, lat, lng, signal } = {}) => {
  const params = { page, limit }
  if (lat != null && lng != null) {
    params.lat = lat
    params.lng = lng
  }

  const { data } = await axiosClient.get('/api/users/discover/nearby', {
    params,
    signal
  })
  return data
}

export const fetchSearchGlobal = async ({ q, page = 1, limit = 20, signal } = {}) => {
  const { data } = await axiosClient.get('/api/users/discover/search-global', {
    params: { q, page, limit },
    signal
  })
  return data
}
